import React from 'react';
import cn from 'classnames';
import { random } from '../../../utils/utils';
import { Visibility } from '../../../types/common-types';
import Icon from '../icon';
import './style.scss';

interface CheckBoxProps {
  id?: string;
  error?: boolean;
  required?: boolean;
  value: boolean;
  style?: object;
  visibility?: Visibility;
  children: React.ReactNode;
  className?: string;
  styleName?: string;
  helperText?: string;
  onChange: (value: { id: string; value: boolean; error: boolean }) => void;
}

const tryToBool = (str: string | boolean) => {
  if (str === 'false') return false;
  if (str === 'true') return true;
  return str;
};

const Checkbox: React.FC<CheckBoxProps> = ({
  id = '',
  error = false,
  visibility = Visibility.Visible,
  children,
  value,
  style,
  required = false,
  onChange,
  className,
  helperText,
}) => {
  const uniqId = random();
  const uId = `id-${uniqId}`;
  const isChecked = tryToBool(value);
  const handleChange = () => {
    if (visibility === Visibility.Disabled) return;
    const valueF = !tryToBool(value);
    const isError = required && !valueF;
    onChange({ id, value: valueF, error: isError });
  };
  return (
    <div
      id={id}
      style={style}
      className={className}
      data-cy="check"
      styleName={cn('checkbox', {
        disabled: visibility === Visibility.Disabled,
        hidden: visibility === Visibility.Hidden,
        error,
        checked: isChecked,
      })}
    >
      <div styleName="checkbox__content">
        <div styleName="checkbox__box">
          <input
            id={uId}
            value={value ? value.toString() : ''}
            type="checkbox"
            onChange={handleChange}
          />
          <Icon
            styleName="checkbox__icon"
            error={error}
            value={isChecked ? 'checkbox_on' : 'checkbox_off'}
          />
        </div>
        <label styleName="checkbox__label" htmlFor={uId}>
          {children}
        </label>
      </div>
      {helperText && (
        <div data-cy-prop="errorMsg" styleName={cn('checkbox__helperText')}>
          {helperText}
        </div>
      )}
    </div>
  );
};

export default Checkbox;
